module.exports = __webpack_public_path__ + "img/prototype.33e7dba5.png";